import API from "serviceshift-ui/api-client";

export default {
  fetchAccountingCategories({ commit }) {
    return API.accounting.getAllCategories().then((response) => {
      commit("replace", {
        state: "accountingCategories",
        data: response.data,
      });
    });
  },
  createAccountingCategory(_, data) {
    return API.accounting.createCategory(data);
  },
  updateAccountingCategory(_, data) {
    return API.accounting.updateCategory(data.accounting_category.id, data);
  },
  deleteAccountingCategory(_, id) {
    return API.accounting.deleteCategory(id);
  },
};
